import { PageViewTracker } from '@belong/common';
import { Image, Text } from '@belong/ui';
import { CUSTOM_404_STRINGS } from 'src/features/404/404.strings';

export default function Custom404() {
  return (
    <PageViewTracker name="404">
      <div className="container">
        <div className="pt-3xl flex flex-col items-center justify-center text-center">
          <Text variant="h1" fontWeight="semibold" className="mb-xs">
            {CUSTOM_404_STRINGS.title}
          </Text>
          <Text className="mb-xl">{CUSTOM_404_STRINGS.description}</Text>
          <Image
            src="/404/belong_404_city_general_01.svg"
            className="mt-2xl h-auto w-full"
            alt="404"
          />
        </div>
      </div>
    </PageViewTracker>
  );
}
